//#region
import { useState, useEffect, useRef } from 'react';
// material
import { Container, InputAdornment, Stack, Box, List, ListItem, ListItemIcon, ListItemText, TextField, Typography, DialogActions, Button, CircularProgress, Alert, MenuItem,Select,InputLabel,
  Pagination, Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Modal, Fade, IconButton,Paper } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast';
// components
import Page from "../components/Page";
import Loader from "./Loader";
import { CalculatedFieldsTable } from '../components/_calculatedFields/tables';
import Popup from '../components/Popup';
import Controls from '../components/controls/Controls';
import { getDatasets } from '../config/services/datasets';
import {deleteMeasure} from '../config/services/measures'
import { getAllMeasuresList } from '../config/services/measures';
import { addVersion } from '../config/services/config'
import { useNavigate } from 'react-router-dom';
// import SearchIcon from "../assets/icons/icon_search.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/icon_search.svg"
import { ReactComponent as StringIcon } from "../assets/icons/icon_string.svg"
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';

import CancelIcon from '@mui/icons-material/Cancel';
import { FixedSizeList  } from "react-window";
import { ReactComponent as InputSearchIcon } from "../assets/icons/icon-feather-search.svg"
import { makeStyles } from "@mui/styles";

import AutoSizer from "react-virtualized-auto-sizer";



const useStyles = makeStyles({
    header: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        marginTop: '-8px',
    },
    search: {
        marginBottom: "1px",
    },
    card: {
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        display:'flex',
        backgroundColor: "#fff4f0",
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
          backgroundColor: '#f6f6f6'
        }
    }
});


export default function DatasetsApp() {
 
  const [search, setSearchValue] = useState('')
  const [sortObj, setSortObj] = useState({ sortKey: 'createdAt', sortOrder: '-1' })
  const [loader, setLoading] = useState(false)
  const [pageNo, setPagination] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [deleteObj, setDeleteObj] = useState({ dataSetId: '', dataSetName: '' })
  const [deletePopup, setDeletePopup] = useState(false)
  const [dataSetList,setDatasetList] = useState([])
  const [searchDataSetInput,setSearchDataSetInput] = useState('')
  const [deleteMeasDataSetMenuOpen,setDeleteMeasDataSetMenuOpen] = useState(false)
  const [deleteMeasDataSetName,setDeleteMeasDataSetName] = useState('')
  const [deleteMeasDataSetId,setDeleteMeasDataSetId] = useState('')
  const [calculatedFields,setCalculatedFields] = useState([])
  const [calculatedFieldTotalCount, setCalculatedFieldTotalCount] = useState(0)
  const [delMeasureSearchInput,setDelMeasureSearchInput] = useState('')
  const [selectedStatus,setSelectedStatus] = useState('all');
  const [statusMenuOpen, setStatusMenuOpen] = useState(false)

  const classes = useStyles();

  const handleStatusMenuOpen = () => {
    setStatusMenuOpen(!statusMenuOpen)
  }

  const handleDatasetMeasSelect = (e,id) => {
    const { value } = e.target;
    setDeleteMeasDataSetName(value)
    setDeleteMeasDataSetMenuOpen(false)
    setDeleteMeasDataSetId(id)
    fetchAllMeasureList(id)
  }
 


   const handleDeleteMeasDataSetMenuOpen = () => {
    setSearchDataSetInput('')
    setDeleteMeasDataSetMenuOpen(!deleteMeasDataSetMenuOpen)
  }

  const fetchAllMeasureList = async (id) => {

  if(id || deleteMeasDataSetId || delMeasureSearchInput) {
    

    setLoading(true)
    const response = await getAllMeasuresList({search: delMeasureSearchInput , sortKey: 'displayName', sortOrder: 1,dataSetId: id || deleteMeasDataSetId, getAll: true, calculated: true,  pageNo: (pageNo - 1), count: itemsPerPage, search, ...sortObj, status: selectedStatus })
    setCalculatedFields(response?.result)
    setCalculatedFieldTotalCount(response?.totalCount)
    setLoading(false)
}
}
  
  let totalPages = Number((calculatedFieldTotalCount / itemsPerPage).toFixed(0))


 const fetchAllDatasetsList = () => {
    let params = { search: searchDataSetInput, sortKey: 'displayName', sortOrder: '1' }
    getDatasets(params).then((res) => {
      if(res?.result?.length) {
        setDatasetList(res?.result);
      }
    });
  }
  
  useEffect(() => fetchAllDatasetsList(),[searchDataSetInput])
  useEffect(() => fetchAllMeasureList(),[pageNo, search,sortObj,itemsPerPage,selectedStatus])

 
  const deleteCalcField = params => {
    setDeleteObj({ _id: params?._id, name: params?.name })
    setDeletePopup(true)
  }

  const submitDeleteCalcField = () => {
    let { _id } = deleteObj
    deleteMeasure({ measureId: _id })
      .then(res => {
        fetchAllMeasureList()
        handleCancelDelete()
        toast.success(res?.message)
      })
  }
  const handlePagination = (e, pageNumber) => {
    setPagination(pageNumber)
  }

  const handleSearch = (e) => {
    let { value } = e.target
    setPagination(1)
    setSearchValue(value, () => setPagination(1))
  }


  const handleCancelDelete = () => {
    setDeletePopup(false, () => {
      setDeleteObj({})
    })
  }

  const handleStatusSelect = (e) => {
    setSelectedStatus(e.target.value)
  }


  const dataSetMeasListSelectRow = ({index, style, data}) => {
   let label = data[index]?.dataSetName
    let value = data[index]?.dataSetName
    let dataSetId = data[index]?._id

     return <div style={style} key={value}>
            <MenuItem onClick={e => handleDatasetMeasSelect({ target: { value: value } },dataSetId)} className="menu-item flex" value={value}>
                &#8288;<ListItemText className="text-plain" primary={label} />
            </MenuItem>
        </div>
}




  return (
    <>
      <Page title="Extramarks | Datasets " className="main-container datasets_container">
        <Container className='table_max_width'>
          <Grid container alignItems="left" justifyContent="flex-start" mb={2} spacing={2.5} >
            <Grid item xs={12} sm={6} md={6} lg={6} className="datasets_header" >
              <TextField
                className={`inputRounded search-input`}
                type="search"
                placeholder="Search by Field name"
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

             <Grid item xs={12} sm={6} md={6} lg={6} display="flex" alignItem="center" >
            
              <Grid container justifyContent="flex-end" spacing={2.5} style={{marginRight:'14px'}}>
                <Grid item xs={8} sm={8} md={8} lg={8} display="flex" justifyContent="flex-end" alignItems="center" >
               <Typography>Select Status</Typography>
               <Select 
                    disabled={!deleteMeasDataSetName}
                    style={{width:'100%'}}
                    value={selectedStatus} 
                    open={statusMenuOpen}
                    onClose={handleStatusMenuOpen}
                    onOpen={handleStatusMenuOpen}
                    MenuProps={{
                        classes:{
                            root: `form-select-menu`
                        }
                    }}

                    onChange={handleStatusSelect}
                >  
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="deleted">Deleted</MenuItem>
                    <MenuItem value="hidden">Hidden</MenuItem>
                </Select>
              </Grid>
  
              </Grid>
              <Grid container justifyContent="flex-end" spacing={2.5}>
                <Grid item xs={12} sm={12} md={12} lg={12} display="flex" justifyContent="flex-end" alignItems="center" >
               <Typography>Select DataSet</Typography>
               <Select 
                    style={{width:'100%'}}
                    value={deleteMeasDataSetName} 
                    renderValue={(selected) => selected }
                    open={deleteMeasDataSetMenuOpen}
                    onClose={handleDeleteMeasDataSetMenuOpen}
                    onOpen={handleDeleteMeasDataSetMenuOpen}
                    MenuProps={{
                        classes:{
                            root: `form-select-menu`
                        }
                    }}
                >
                    <div className={classes.header}>
                        <Paper className={classes.card} elevation={3}>
                            <IconButton className="form-icon-btn" onClick={handleDeleteMeasDataSetMenuOpen} color="primary"> <CancelIcon /></IconButton>
                        </Paper>
                    </div>
                    <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                    onChange={e => setSearchDataSetInput(e.target.value)}
                    InputProps={{
                    endAdornment: (
                        <InputAdornment position="start">
                            <InputSearchIcon className="input_search_icon" sx={{mr: '8px'}} />
                        </InputAdornment>
                        ),
                    }} />

                   <div className={`virtual-filter-div ` + ((dataSetList.length) ? 'filter-data-exists' : ``)}>
                    <AutoSizer>
                        {({ height, width }) => ( 
                        <FixedSizeList
                            className="List"
                            height={dataSetList.length?height:20}
                            itemCount={(dataSetList ).length}
                            width={width - 6}
                            itemData={(dataSetList )}
                            itemSize={60}
                        >
                            {dataSetMeasListSelectRow}
                        </FixedSizeList>
                        )}
                     </AutoSizer>
                     </div>

                </Select>
              </Grid>
              </Grid>
              </Grid>

          </Grid>
          {loader && <Loader />}
          {calculatedFields?.length ? <CalculatedFieldsTable list={calculatedFields} deleteCalcField={deleteCalcField} 
          pageNo={pageNo} itemsPerPage={itemsPerPage} setLoading={setLoading}  /> :
            <Alert severity="error">No Content Available!</Alert>}
        </Container>

        <div className='center cm_pagination'>
          <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo} />
        </div>
      </Page>


       <Popup title={`Are you sure to delete this Measure "${deleteObj?.name}" ?`} openPopup={deletePopup} setOpenPopup={handleCancelDelete} onClose={false}>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">Cancel</Button>
                    <Button onClick={submitDeleteCalcField} color="error" autoFocus>Delete</Button>
                </DialogActions>
        </Popup>

    </>
  );
}
